import React, { useState, useEffect } from 'react';

type LoadingSpinnerProps = {
  outerClass?: string;
  scroll?: boolean;
  children?: React.ReactNode;
  message?: string;
};

/**
 * @deprecated Use { Spinner } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/spinner--docs
 */

const LoadingSpinner = ({
  outerClass,
  scroll,
  children,
  message,
}: LoadingSpinnerProps) => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (!hasScrolled && scroll) {
      window.scrollTo(0, 0);
      setHasScrolled(true);
    }
  }, [hasScrolled, scroll]);

  return (
    <div className={`data-loading-wrap ${outerClass}`}>
      {children}
      {message && message.length > 0 && (
        <div className="data-loading-message">{message}</div>
      )}
      <div
        className="data-loading-spinner"
        data-testid="shared__data-loading-spinner"
      >
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default LoadingSpinner;
